import { getChannelAPIPath } from '@treasury/core/http';

StpService.$inject = ['$resource'];

export default function StpService($resource) {
    const resourceUrl = `${getChannelAPIPath()}stp/`;

    return {
        approve,
        batchApprove,
        batchReject,
        cancel,
        create,
        getAccounts,
        getFilterAccounts,
        getAll,
        reject,
        search,
    };

    /**
     * @returns { Promise<import('@treasury/api/channel').StpModelDto> }
     */
    function create(model) {
        return $resource(`${resourceUrl}create`).save(model).$promise;
    }

    function getAccounts() {
        return $resource(`${resourceUrl}getAccounts`).query().$promise;
    }

    function getFilterAccounts() {
        return $resource(`${resourceUrl}getFilterAccounts`).query().$promise;
    }

    function getAll() {
        return $resource(`${resourceUrl}getAll`).query().$promise;
    }

    function batchApprove(batch) {
        return $resource(
            `${resourceUrl}batchApprove`,
            {},
            { save: { method: 'POST', isArray: true } }
        ).save(batch).$promise;
    }

    function batchReject(batch) {
        return $resource(
            `${resourceUrl}batchReject`,
            {},
            { save: { method: 'POST', isArray: true } }
        ).save(batch).$promise;
    }

    function approve(id, comments) {
        return $resource(`${resourceUrl}:id/approve`, { id }).save({ key: id, value: comments })
            .$promise;
    }

    function reject(id, comments) {
        return $resource(`${resourceUrl}:id/reject`, { id }).save({ key: id, value: comments })
            .$promise;
    }

    function cancel(id, comments) {
        return $resource(`${resourceUrl}:id/cancel`, { id }).save({ key: id, value: comments })
            .$promise;
    }

    function search(model) {
        return $resource(
            `${resourceUrl}search`,
            {},
            { search: { method: 'POST', isArray: true } }
        ).search(model).$promise;
    }
}
